<template>
  <div class="data-log">
    <div class="filter-wrap">
      <common-select
        label="全部时间"
        type="time"
        @select="logSearchBody['dates'] = $event"
      ></common-select>
      <common-select
        label="所有人"
        :options="operatorOptions"
        @select="logSearchBody['op'] = $event ? [$event] : []"
      ></common-select>
      <common-select
        :options="typeOptions"
        @select="logSearchBody['types'] = $event ? [$event] : []"
      ></common-select>
    </div>
    <div v-ps class="log-list" @ps-y-reach-end="loadMore">
      <div class="log-item font-main" v-for="log in filteredLogs" :key="log.id">
        <div class="log-content">
          <staff-popover :staffId="log.creator.id">
            <template v-slot:reference>
              <staff-avatar class="avatar" :size="30" :user="log.creator"></staff-avatar>
            </template>
          </staff-popover>
          <div class="log-text">
            <div class="log-title">{{ log.title }}</div>
            <div v-if="log.type === 'VERIFY'" style="font-size: 12px">
              <div v-html="log.content[0]" v-viewer="{ backdrop: 'static' }" class="log-html"></div>
            </div>
            <div v-else-if="log.detail && log.detail.length" style="font-size: 12px">
              <div v-for="(item, index) in log.detail" :key="index">
                <div v-if="item.many === true">
                  {{ item.ctrlName }}： {{ item.content }}
                  <span @click="changeOpen(item)" class="change-open">
                    {{ item.open ? "收起" : "展开" }}
                  </span>
                  <div v-if="item.open" class="detail">{{ item.ctrlName }}：{{ item.newStr }}</div>
                </div>
                <div v-else-if="item.ctrlType === 'rich'" v-viewer="{ backdrop: 'static' }">
                  {{ item.ctrlName }}：
                  <div v-html="item.oldStr"></div>
                  ->
                  <div v-html="item.newStr"></div>
                </div>
                <div v-else-if="item.ctrlType === 'file'">
                  {{ item.ctrlName }}：
                  <a
                    :class="item.oldExt ? 'external-link pointer' : ''"
                    @click="item.oldExt && download(item.oldExt, item.oldStr)"
                  >
                    {{ item.oldStr }}
                  </a>
                  ->
                  <a
                    :class="item.newExt ? 'external-link pointer' : ''"
                    @click="item.newExt && download(item.newExt, item.newStr)"
                  >
                    {{ item.newStr }}
                  </a>
                  <br />
                </div>
                <div v-else>{{ item.ctrlName }}： {{ item.oldStr }} -> {{ item.newStr }}</div>
              </div>
            </div>
            <div v-else>
              <div
                v-for="(item, index) in log.content"
                :key="index"
                style="font-size: 12px; word-break: break-all"
              >
                {{ item }}
                <br />
              </div>
            </div>
            <div class="log-time">{{ log.time.slice(5) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataLogs } from "@/api/sheet/sheetData"
import CommonSelect from "@/components/UIComponents/CommonSelect"
import dj from "dayjs"
import { signature } from "@/utils/aliOss"
import { loadingService } from "@/utils/ui"
import { logTitleMap } from "./static"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import StaffAvatar from "@/components/StaffAvatar"
let isBetween = require("dayjs/plugin/isBetween")
dj.extend(isBetween)
export default {
  name: "DataLog",
  props: {
    dataId: String,
    appId: String
  },
  components: {
    StaffAvatar,
    CommonSelect,
    StaffPopover
  },
  watch: {
    dataId: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },
  data() {
    return {
      logSearchBody: { types: [], op: [], dates: null },
      typeOptions: [
        { value: "user", label: "用户操作" },
        { value: "sys", label: "系统操作" },
        { value: "verify", label: "审批" }
      ],
      logs: [],
      lastLogId: null,
      hasMore: true,
      loading: false
    }
  },
  computed: {
    operatorOptions() {
      let res = {}
      this.logs.forEach(log => {
        let id = log.creatorId
        res[id] = {
          value: id,
          label: log.creator.name
        }
      })
      return Object.values(res)
    },
    filteredLogs() {
      let searchBody = this.logSearchBody
      return this.logs.filter(log => {
        // 时间
        if (
          searchBody.dates &&
          log.createAt &&
          !dj(log.createAt).isBetween(searchBody.dates[0], searchBody.dates[1])
        ) {
          return false
        }
        // 操作人
        if (searchBody.op.length && !searchBody.op.includes(log.creatorId)) {
          return false
        }
        // 类型 最后一个判断
        if (searchBody.types.length) {
          for (let type of searchBody.types) {
            switch (type) {
              case "sys":
                if (log.creatorId.length < 24) {
                  return true
                }
                break
              case "user":
                if (log.creatorId.length === 24) {
                  return true
                }
                break
              case "verify":
                if (log.type.startsWith("VERIFY")) {
                  return true
                }
                break
            }
          }
          return false
        }
        return true
      })
    }
  },
  methods: {
    init() {
      this.lastLogId = null
      this.hasMore = true
      this.logSearchBody = { types: [], op: [], dates: null }
      this.logs = []
      this.loadMore()
    },
    loadMore() {
      if (!this.hasMore || this.loading) return
      // 获取log
      this.loading = true
      getDataLogs({ dataId: this.dataId, appId: this.appId, lastLogId: this.lastLogId })
        .then(logs => {
          if (logs.length < 20) this.hasMore = false
          this.lastLogId = logs[logs.length - 1]?.id
          this.logs = this.logs.concat(
            logs.map(log => {
              let title = logTitleMap[log.type]
              if (log.type === "BUTTON") {
                title = "【" + log.subTitle + "】了记录"
              }
              title =
                log.creator.name + (log.companyName ? "(" + log.companyName + ")" : "") + title
              let content = log.content ? log.content.split("；") : []
              let length = content.length
              if (length && !content[length - 1]) {
                content = content.slice(0, length - 1)
              }
              log.detail = log.detail.map(item => {
                if (this._.keys(item).includes("oneFlag")) {
                  if (item.oneFlag === true) return item
                  else if (item.oneFlag === false) {
                    let addStr = item.oldExt === "无标题" ? "" : "增加了" + item.oldExt
                    let delStr = item.newExt === "无标题" ? "" : "减少了" + item.newExt
                    return Object.assign({}, item, {
                      many: true,
                      open: false,
                      content: addStr + (addStr && delStr ? ", " : "") + delStr
                    })
                  }
                } else {
                  return item
                }
              })
              return Object.assign(log, {
                title,
                time: log.createAt.replace(" ", "\n"),
                content
              })
            })
          )
        })
        .finally(() => (this.loading = false))
    },
    download(path, name) {
      const loadingInstance = loadingService()
      signature({ objectName: path, downloadName: name }).then(res => {
        loadingInstance.close()
        window.open(res)
      })
    },
    changeOpen(item) {
      item.open = !item.open
    }
  }
}
</script>

<style lang="scss" scoped>
.data-log {
  display: flex;
  flex-flow: column;
  overflow: hidden;
  padding-bottom: 60px;
  padding-left: 10px;
  height: 100%;
  .log-filter {
    margin-top: 23px;
  }
  .filter-wrap {
    display: flex;
    min-height: 20px;
    .common-select {
      margin-right: 20px;
    }
  }
  .log-list {
    overflow: hidden;
    flex: auto;
    margin-top: 17px;
    .log-item {
      display: flex;
      .log-content {
        display: flex;
        justify-content: space-between;
        padding: 0 10px 10px 0;
        border-left: 2px solid $color-bg-home;
        width: 100%;
        .avatar {
          flex-shrink: 0;
        }
        .log-text {
          flex: 1;
          border-bottom: 1px solid #eaecf0;
          padding-bottom: 10px;
          ::v-deep .log-html {
            img {
              width: 210px;
            }
          }
          .change-open {
            color: #198afa;
            cursor: pointer;
          }
          .detail {
            background-color: #ebedf2;
            padding: 4px 6px;
            margin: 6px 0;
          }
          .log-title {
            margin-left: 0;
            line-height: 25px;
            font-weight: 500;
            font-size: 13px;
          }
          .log-time {
            font-size: 12px;
            margin-top: 5px;
          }
          .external-link {
            color: $color-main;
          }
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
